/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'app/components/common/SideBar.jsx';
import { Breakpoint } from 'react-socks';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import Account from 'app/views/Settings/Account.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class ClientAccount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            navItems: [
                {
					iconClass: 'fa fa-paper-plane sidebar-icon',
					label: 'Social Accounts',
					labelClass: 'sidebar-label',
					link: '/socials',
					badgeValueCallback: this.props.socials.counts,
					badgeClass: 'sidebar-item-badge'
				}
            ]
        };

    }

    render() {
        return (
            <div>
				<ErrorBoundary level="view" {...this.props}>
					<Breakpoint desktop only>
						<Sidebar navItems={this.state.navItems} app="client"/>
					</Breakpoint>
					<Account appName={"client"} {...this.props}/>
				</ErrorBoundary>
			</div>
        );
    }
}

ClientAccount.displayName = "ClientAccount";

ClientAccount.propTypes = {

};

ClientAccount.defaultProps = {

};

export default ComponentWithContext(ClientAccount);
